// extracted by mini-css-extract-plugin
export var container = "HowItWorks-module--container--7af0d";
export var icon = "HowItWorks-module--icon--7f9b3";
export var imageContainer = "HowItWorks-module--image-container--44c00";
export var straightLine = "HowItWorks-module--straight-line--62984";
export var typography = "HowItWorks-module--typography--77aa8";
export var typographyContainer = "HowItWorks-module--typography-container--09497";